/**
 * Step2ExamTypes — Tipos de Exame step of the RiskApplicationModal stepper.
 */

import React from 'react';
import {
  Stack,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Controller, type Control } from 'react-hook-form';
import { EXAM_TYPES, OCC_EXAM_TYPE_LABELS } from '../../../types/occupationalRisk';
import type { ExamType } from '../../../types/occupationalRisk';
import type { StepperFormValues } from '../RiskApplicationModal';

// ExamType is a subset of string; the form stores string[] and we treat each as ExamType

interface Step2ExamTypesProps {
  control: Control<StepperFormValues>;
  disabled: boolean;
}

export const Step2ExamTypes: React.FC<Step2ExamTypesProps> = ({ control, disabled }) => (
  <Controller
    name="examTypes"
    control={control}
    render={({ field }) => {
      const selected = (field.value as string[]);

      const toggle = (type: ExamType) => {
        if (selected.includes(type)) {
          field.onChange(selected.filter((t) => t !== type));
        } else {
          field.onChange([...selected, type]);
        }
      };

      return (
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              type="button"
              size="small"
              variant="outlined"
              disabled={disabled}
              onClick={() => field.onChange([...EXAM_TYPES])}
            >
              Selecionar todos
            </Button>
            <Button
              type="button"
              size="small"
              variant="outlined"
              color="inherit"
              disabled={disabled}
              onClick={() => field.onChange([])}
            >
              Limpar
            </Button>
          </Box>

          <Typography variant="body2" color="text.secondary">
            Selecione os tipos de exame que incluem este risco (opcional).
          </Typography>

          <FormGroup>
            {EXAM_TYPES.map((type) => (
              <FormControlLabel
                key={type}
                control={
                  <Checkbox
                    checked={selected.includes(type)}
                    onChange={() => toggle(type)}
                    disabled={disabled}
                    size="small"
                  />
                }
                label={OCC_EXAM_TYPE_LABELS[type]}
              />
            ))}
          </FormGroup>
        </Stack>
      );
    }}
  />
);

export default Step2ExamTypes;
